import { render, staticRenderFns } from "./waitInspectDetail.vue?vue&type=template&id=1c6d51ac&scoped=true&"
import script from "./waitInspectDetail.vue?vue&type=script&lang=js&"
export * from "./waitInspectDetail.vue?vue&type=script&lang=js&"
import style0 from "./waitInspectDetail.vue?vue&type=style&index=0&id=1c6d51ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6d51ac",
  null
  
)

export default component.exports